import Component from '../../../shared/component';

export default class MentorshipRatingList extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$moreButton = this.$element
      .parent()
      .find('.mentorshipRatingList-moreTrigger');
    this.$actionsDiv = this.$element
      .parent()
      .find('.mentorshipRatingList-actions');

    this.isFetchingMentorshipRatings = false;
    this.shouldFetchMentorshipRatings = true;

    this.bindEvents();
  }

  bindEvents() {
    this.handleMoreClick = this.handleMoreClick.bind(this);

    this.$moreButton.on('click', this.handleMoreClick);
  }

  unbindEvents() {
    this.$moreButton.off('click', this.handleMoreClick);
  }

  fetchMentorshipRatings() {
    this.isFetchingMentorshipRatings = true;

    const mentorshipRatingIds = this.$element
      .find('.mentorshipRating')
      .toArray()
      .map((mentorshipRating) => {
        return $(mentorshipRating).data('mentorship-rating-id');
      });

    if (mentorshipRatingIds.length) {
      $.get(this.$element.attr('action'), {
        // eslint-disable-next-line camelcase
        exclude_ids: mentorshipRatingIds,
      }).done((data, code) => this.handleMentorshipRatingsSuccess(data, code));
    } else {
      this.isFetchingMentorshipRatings = false;
    }
  }

  appendMentorshipRatings(html) {
    this.$element.append(html);
  }

  hideMoreButton() {
    if (this.$actionsDiv) {
      this.$actionsDiv.hide();
    }
  }

  handleMoreClick() {
    if (
      this.shouldFetchMentorshipRatings &&
      !this.isFetchingMentorshipRatings
    ) {
      this.fetchMentorshipRatings();
    }
  }

  handleMentorshipRatingsSuccess(data, code) {
    if (code === 'nocontent') {
      this.hideMoreButton();
    } else {
      if (String(data).trim() !== '') {
        this.appendMentorshipRatings(data);
      } else {
        // We’ve reached the bottom of the list, stop trying to fetch mentorship ratings
        this.shouldFetchMentorshipRatings = false;
      }

      this.isFetchingMentorshipRatings = false;
    }
  }
}
